import { DestroyRef, Directive, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DialogService } from '../services/dialog.service';
import { CanBlockNavigation } from './interfaces';
import { RouteNavigationService } from './route-navigation.service';

@Directive()
export abstract class AbstractRoute implements CanBlockNavigation {
  protected readonly dialogService = inject(DialogService);

  private readonly routeNavigationService = inject(RouteNavigationService);

  constructor() {
    this.routeNavigationService.register(this);

    inject(DestroyRef).onDestroy(() => {
      this.routeNavigationService.unregister(this);
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (!this.canUnload()) {
      return this.dialogService.showConfirmDialog().afterClosed();
    }

    return true;
  }

  abstract canUnload(): boolean;
}
